/* eslint-disable func-names, max-len */
const $compare = $('.headerNav .navArea .navbar');

if ($compare.length) {
  require.ensure(['knockout', 'knockout-mapping'], () => {
    const ko = require('knockout');
    require('knockout-mapping');

    const self = {};

    const viewModel = {};

    viewModel.RemoveProduct = function (data) {
      viewModel.CompareAgilityIds.remove(data.AgilityID.toString());
    };

    viewModel.RemoveAll = function () {
      viewModel.CompareAgilityIds.removeAll();
    };

    let oldAgilityIds = [];

    const refreshProducts = function () {
      const agilityIds = viewModel.CompareAgilityIds();

      if (agilityIds.length > 0 || oldAgilityIds.length > 0) {
        $.ajax({
          type: 'POST',
          url: '/SiteFiles/WebServices/CompareProducts.asmx/AddRemoveProducts',
          data: `{ newAgilityIds: [${agilityIds.map(Number)}], oldAgilityIds: [${oldAgilityIds.map(Number)}] }`,
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
          success(data) {
            viewModel.CompareUrl(data.d.ComparisonUrl);

            let products = data.d.Products;
            const length = products.length;
            if (length < 4) {
              products = products.concat(new Array(4 - length));
            }

            viewModel.CompareProductsPreview(products);

            oldAgilityIds = agilityIds.slice(0);
          },
          error() {
            //
          },
        });
      }
    };

    self.initialise = function () {
      viewModel.CompareAgilityIds = ko.observableArray([]);
      viewModel.CompareProductsPreview = ko.observableArray([]);
      viewModel.CompareUrl = ko.observable();
      viewModel.ShowCheckbox = function (agilityId) {
        const ids = viewModel.CompareAgilityIds().map(Number);

        if (ids.indexOf(agilityId) > -1) {
          return true;
        }

        if (ids.length >= 4) {
          return false;
        }

        return true;
      };
      viewModel.CompareProductsPreview.removeAll();

      viewModel.CompareAgilityIds.subscribe(refreshProducts);

      const element = $compare[0];
      ko.cleanNode(element);
      ko.applyBindings(viewModel, element);

      // Binding to only the elements we need
      $('.compare-box').each(function () {
        const $this = $(this);
        const elem = $this[0];
        ko.cleanNode(elem);
        ko.applyBindings(viewModel, elem);
      });

      $.ajax({
        type: 'POST',
        url: '/SiteFiles/WebServices/CompareProducts.asmx/GetSessionProducts',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        success(data) {
          viewModel.CompareAgilityIds(data.d.map(String));
        },
        error() {
          //
        },
      });
    };

    self.initialise();
  });
}
